<template>
  <v-flex d-block xs12>
    <v-card>
      <v-card-title>
        <h3 style="display: inline-block;">Services </h3>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-text>
        <table class="v-table theme--light">
          <thead>
          <tr>
            <th class="column text-xs-left">Title</th>
            <th class="column text-xs-left">Price</th>
            <th class="column text-xs-left">ExternalId</th>
            <th class="column text-xs-left">Hidden</th>
            <th class="column text-xs-left">Effective Contractor</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <client-service-item v-for="service in sortedServices"
                        v-bind:key="service.id"
                        v-bind:item="service"
                        :availableContractors="availableContractors"
                        :availableClients="availableClients"
                        :availableServices="availableServices"
                        @editItem="handleEditItemEvent"
                        @deleted="handleClientServiceDeletedEvent">
          </client-service-item>
          </tbody>
        </table>
      </v-card-text>
    </v-card>
    <client-service-form :visible="editFormVisible"
                         :selectedItem="selectedServiceItem"
                         :availableContractors="availableContractors"
                         @updated="handleClientServiceUpdatedEvent"
                         @close="handleFormCloseEvent"></client-service-form>
  </v-flex>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

import ClientServiceItem from './ClientServiceItem'
import ClientServiceForm from './ClientServiceForm'
import _ from 'lodash'

export default {
  name: 'client-services',
  components: {
    ClientServiceItem,
    ClientServiceForm
  },
  props: {
    items: {
      type: Array
    }
  },
  data () {
    return {
      loading: false,
      editFormVisible: false,
      selectedServiceItem: null
    }
  },
  computed: {
    ...mapState({
      availableContractors: "availableContractors",
      availableClients: "availableClients",
      availableServices: "availableServices"
    }),
    sortedServices () {
      return _.sortBy(this.items, 'code')
    }
  },
  methods: {
    handleFormCloseEvent () {
      this.editFormVisible = !this.editFormVisible
    },
    handleEditItemEvent (item) {
      this.selectedServiceItem = item
      this.editFormVisible = !this.editFormVisible
    },
    handleClientServiceUpdatedEvent (updatedService) {
      this.$emit('clientServiceUpdated', updatedService)
    },
    handleClientServiceDeletedEvent (deletedService) {
      this.$emit('clientServiceDeleted', deletedService)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sales/ClientServices.vue